import { useCallback, useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getAllSubAccounts } from '../../services/subAccountsService';
import { apiParamsState } from '../../storage/app';
import { allSubAccountsState, editingSubAccountState, updateSubAccountsState } from '../../storage/subAccounts';
import useUpdateEffect from '../../hooks/useUpdateEffect';

function AllSubAccountsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setAllSubAccounts = useSetRecoilState(allSubAccountsState);
  const updateSubAccounts = useRecoilValue(updateSubAccountsState);
  const resetUpdateSubAccounts = useResetRecoilState(updateSubAccountsState);
  const resetEditingSubAccount = useResetRecoilState(editingSubAccountState);

  const loadAllSubAccounts = useCallback(async () => {
    const invalid = !apiParams?.clientId || !apiParams?.subClientId;
    if (invalid) return;

    const { subAccounts, error } = await getAllSubAccounts(apiParams.clientId, apiParams.subClientId);
    if (!error && subAccounts) {
      setAllSubAccounts(subAccounts);
    } else {
      setAllSubAccounts(undefined);
    }
  }, [apiParams?.clientId, apiParams?.subClientId, setAllSubAccounts]);

  useEffect(() => {
    loadAllSubAccounts();
  }, [apiParams?.clientId, apiParams?.subClientId, loadAllSubAccounts]);

  useUpdateEffect(() => {
    if (!updateSubAccounts) return;

    loadAllSubAccounts().finally(() => {
      resetUpdateSubAccounts();
      resetEditingSubAccount();
    });
  }, [updateSubAccounts]);

  return null;
}

export default AllSubAccountsProvider;
